export const getCountry = <T extends string>(brandId: string, supported?: Array<T>): T => {
	const country = brandId.substring(brandId.lastIndexOf('_') + 1).toUpperCase()

	if (supported && !supported.includes(country as T)) {
		throw new Error(`Invalid brand ${brandId}, only ${supported.join(', ')} supported`)
	}

	return country as T
}
